import type React from 'react';

import type { ResolvedExperimentData } from '@change-corgi/experiments/configs';

import { useTrackExperimentExposureOnMount } from '#src/app/shared/hooks/tracking';

type Props = Readonly<{
	/**
	 * The resolved experiment data to track exposure for.
	 */
	experiment: ResolvedExperimentData;
	/**
	 * Reset keys that re-fire the event when changed. Required when the same component instance
	 * is reused across logical contexts (e.g. SPA petition change with no remount), since
	 * variations are deterministic per user and would otherwise dedup the legitimate fire.
	 */
	resetKeys?: readonly unknown[];
}>;

/**
 * Declarative wrapper around `useTrackExperimentExposureOnMount` for downstream components that
 * render only real content and have no other reason to call hooks — drop this in as a sibling
 * instead of adding the hook call to the component body. Renders nothing.
 *
 * @example
 * <TrackExperimentExposure experiment={experiment} />
 */
export const TrackExperimentExposure: React.FC<Props> = ({ experiment, resetKeys }) => {
	useTrackExperimentExposureOnMount(experiment, resetKeys ? { resetKeys } : undefined);

	return null;
};
